import http from '../APIs/olonaTeams'

export default class FavoriteAPI {
    // favorites
  public addFavorite = (data: any, token: any) => http.post("/addFavorite", data, token)

  public getFavorites = (id: string | number, token: any) => http.get(`/favorites?id=${id}`, token)

  public deleteFavorites = (id: string | number, id_candidat: string | number, token: any) => http.delete(`/favorite/${id}/${id_candidat}`, token)
}